import { useTranslation } from 'react-i18next';

import { useModal } from 'Store/modal';

const useConfirmCreateModal = () => {
  const { t } = useTranslation('schedule-ruleset');
  const { onOpenModal, onResetModal } = useModal();

  const onOpenConfirmCreateModal = (createRuleset) => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'confirm',
      title: t('createConfirmTitle'),
      contentDescription: t('createConfirmDescription'),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('buttonYesSave'),
      secondaryButtonText: t('buttonCancel'),
      onClickPrimaryButton: () => {
        createRuleset();
        onResetModal();
      },
    });
  };

  return { onOpenConfirmCreateModal };
};

export default useConfirmCreateModal;